import { render, staticRenderFns } from "./panel_zhuyuan.vue?vue&type=template&id=d54d8dd8&scoped=true&"
import script from "./panel_zhuyuan.vue?vue&type=script&lang=js&"
export * from "./panel_zhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./panel_zhuyuan.vue?vue&type=style&index=0&id=d54d8dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54d8dd8",
  null
  
)

export default component.exports